"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTypes = void 0;
var PaymentTypes;
(function (PaymentTypes) {
    PaymentTypes["API_INTER"] = "api_inter";
    PaymentTypes["CNAB"] = "cnab";
    PaymentTypes["ITAU_SHEET"] = "planilha_itau";
    PaymentTypes["BTG_SHEET"] = "planilha_btg";
    PaymentTypes["STARK"] = "stark";
    PaymentTypes["API_KAMINO"] = "api_kamino";
})(PaymentTypes = exports.PaymentTypes || (exports.PaymentTypes = {}));
